// extracted by mini-css-extract-plugin
module.exports = {"wzxjvst":"wzxjvst"};